import { render } from "./DateAgoDisplay.vue?vue&type=template&id=4b65c184"
import script from "./DateAgoDisplay.vue?vue&type=script&lang=js"
export * from "./DateAgoDisplay.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__